import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LabTestForm from './labTestForm';
import LabTestList from './labTestList';
import LoadingDots from '../../shared/LoadingDots';
import {
  fetchLabTests,
  selectLabTests,
  selectLabTestsLoading,
  selectLabTestsSubmitting
} from '../../../ReduxSlices/LabTests/labTestSlice';
import { createLabRequest } from '../../../ReduxSlices/LabRequests/labRequests';
import { fetchLabTestTypes } from '../../../ReduxSlices/Admin/labTestServiceSlice';
import { selectLabRequests, fetchLabRequests } from '../../../ReduxSlices/LabRequests/labRequests';
import LabRequestCard from './labRequests';

const LabTestSection = ({ patientId, currentUserId, consultationId, role, patientQueueId }) => {
  const dispatch = useDispatch();
  const allLabTests = useSelector(selectLabTests);
  console.log(allLabTests);
  // Filter only lab tests for this patient
  const labTests = allLabTests.filter((test) => test.patient?.id === patientId);
  const loading = useSelector(selectLabTestsLoading);
  const submitting = useSelector(selectLabTestsSubmitting);
  const [doctorNotes, setDoctorNotes] = useState('');
  const labRequests = useSelector(selectLabRequests); // all requests for a patient

  const activeLabRequests = labRequests.filter(
  r => r.status !== "canceled"
);


  const [showForm, setShowForm] = useState(false);
  const [testType, setTestType] = useState('');

 useEffect(() => {
  dispatch(fetchLabTestTypes());
  dispatch(fetchLabRequests(patientId));
  dispatch(fetchLabTests(patientId));
  
}, [dispatch, patientId]);


  const handleTestSubmit = async (formData) => {
  try {
    if (role === 'doctor') {
      await dispatch(
        createLabRequest({
          lab_test_type_id: testType,
          patient_id: patientId,
          consultation_id: consultationId,
          patient_queue_id: patientQueueId,
          doctor_notes: doctorNotes,
        })
      ).unwrap();
    }
       
    setShowForm(false);
    setTestType('');
    setDoctorNotes('');
  } catch (err) {
    console.error(err);
    alert('Error submitting lab test. Please try again.');
  }
};

const pendingLabRequests = labRequests.filter(
  (req) => req.status !== 'paid' && req.status !== 'canceled'
);


  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">

            {!showForm && (
              <button
                type="button"
                onClick={() => setShowForm(true)}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Request Lab Test
              </button>
            )}

            {showForm && (
              <div className="labmodal flex items-center justify-center">
                <div className="bg-white p-6 rounded shadow-md w-full max-w-md relative">
                  <button
                    type="button"
                    onClick={() => setShowForm(false)}
                    className="absolute top-2 right-[15px] text-gray-500 hover:text-gray-700"
                  >
                    ✕
                  </button>
                  <LabTestForm
                    onSubmit={handleTestSubmit}
                    testType={testType}
                    setTestType={setTestType}
                    submitting={submitting}
                    doctorNotes={doctorNotes}
                    setDoctorNotes={setDoctorNotes}
                    role={role}
                  />
                </div>
              </div>
            )}        
       </div>

      {loading && <LoadingDots height={10} width={30} color="#38AD3E" /> }

      {!loading && activeLabRequests.length === 0 && (
        <p className="text-gray-500">No lab tests requested for this patient.</p>
      )}


          {!loading && pendingLabRequests.length > 0 && (
          <div >
            <h3 className="text-lg font-semibold">Lab Requests</h3>
            {pendingLabRequests.map(req => (
              <LabRequestCard key={req.id} request={req} />
            ))}
          </div>
        )}
      {!loading && labTests.length > 0 && (
        <>
       <h3 className="text-lg font-semibold">Lab Test History</h3>

       
        <LabTestList labTests={labTests} />

      
        </>
      )}

    </div>
  );
};

LabTestSection.propTypes = {
  patientId: PropTypes.number.isRequired,
  currentUserId: PropTypes.number.isRequired,
  consultationId: PropTypes.number,
  patientQueueId: PropTypes.number,
};

export default LabTestSection;